export enum Segment {
  WOMEN = 'WOMEN',
  MEN = 'MEN',
}

export const DEFAULT_SEGMENT = Segment.WOMEN;
